import { render, staticRenderFns } from "./order.vue?vue&type=template&id=4b61e093&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61e093",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b61e093')) {
      api.createRecord('4b61e093', component.options)
    } else {
      api.reload('4b61e093', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=4b61e093&scoped=true&", function () {
      api.rerender('4b61e093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/order/order.vue"
export default component.exports